<template>
  <div>

    <el-form ref="form"   :model="form" label-width="220px">

      <el-form-item label="请输入子设备号" style="width: 600px;"    :rules="deviceRules" prop="deviceNumber"    >
        <el-input v-model="form.deviceNumber" style="width: 350px;"   ></el-input>
      </el-form-item>

      <el-form-item   label="请选择关联类型"  style="width: 600px;"   prop="relationType"
  :rules="[{ required: true, message: '请选择关联类型', trigger: 'blur' }]" >
        <el-select v-model="form.relationType" placeholder="请选择" style="width: 350px;"  >
          <el-option label="ID同义" value="1"></el-option>
          <el-option label="购买新车" value="2"></el-option>
          <el-option label="更换屏幕" value="3"></el-option>
          <el-option label="交叉登录" value="4"></el-option>
        </el-select>
    
      </el-form-item>

      <el-form-item label="请输入主设备号"  style="width: 600px;"  :rules="noEmptyRules" prop="mainDevice"   >
        <el-input v-model="form.mainDevice" style="width: 350px;"></el-input>
      </el-form-item>
      <el-form-item label="备注信息"  style="width: 600px;"    :rules="noEmptyRules" prop="reason"  >
        <el-input v-model="form.reason" style="width: 350px;"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click.prevent="addDeviceRelation" type="primary">新增设备关联</el-button>
      </el-form-item>
    </el-form>


    <el-table :data="tableData" stripe style="width: 100%;white-space:pre-wrap" height="750"
      :default-sort="{ prop: 'id', order: 'descending' }">

      <el-table-column prop="id" label="序号"   width="60" >
      </el-table-column>
      <el-table-column prop="device_number" label="device_number">
      </el-table-column>

      <el-table-column prop="date" label="加入日期" width="120">
      </el-table-column>

      <el-table-column prop="reason" label="描述">   </el-table-column>
      <el-table-column prop="author" label="操作者"> </el-table-column>
      <el-table-column prop="relation_type" label="类型" width="120" :formatter="formatRelationType">
      </el-table-column>
      <el-table-column prop="main_device" label="对应主设备">
      </el-table-column>
      <el-table-column prop="update_time" label="修改日期">
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="60">
        <template slot-scope="scope">
          <el-button @click="handleClick(scope.row)" type="text" size="small">删除</el-button>
        </template>
      </el-table-column>



    </el-table>




  </div>
</template>

<script>


export default {


  data() {
    return {
      tableData: [],
      sum: "",
      numberA: 0,
      numberB: 0,
      form:{
        deviceNumber: '',
      reason: '',
      relationType: '',
     mainDevice: '',

      },

     deviceRules: [
        { required: true, message: '设备号不能为空', trigger: 'blur' }
      ],
      noEmptyRules: [
        { required: true, message: '该字段不能为空', trigger: 'blur' }
      ],


    }

  },


  methods: {

    handleClick(row) {
      this.numberA = Math.floor(Math.random() * 100); // 生成0到99之间的随机整数作为数字A
      this.numberB = Math.floor(Math.random() * 100); // 生成0到99之间的随机整数作为数字B

      this.$prompt(
        `请输入数字${this.numberA}和数字${this.numberB}的和`,
        "请仔细确认后再进行删除",
        {
          inputPattern: /^\d+$/,
          inputErrorMessage: "请输入有效的数字",
        }
      )
        .then(({ value }) => {
          const result = parseInt(value);
          if (result === this.numberA + this.numberB) {
            // 用户输入的数字等于两个数字的和，执行删除操作
            this.$http.get("/da/del_device_relation/" + row.id).then((response) => {
              location.reload();
            });
          } else {
            this.$message.error("数字不正确,验证失败，再次提醒请谨慎操作!");
          }
        })
        .catch(() => {
          // 用户点击取消按钮或关闭对话框
        });
    },

    addDeviceRelation() {
  // 验证表单
  this.$refs.form.validate(valid => {
    if (valid) {

      // 发送post 请求
      this.$http.post('da/add_device_relation', this.form)
        .then(response => {
          // 请求成功的处理逻辑
          console.log('设备关联添加成功', response.data);
          // 刷新当前页面
          this.$router.go(0);
        })
        .catch(error => {
          // 请求失败的处理逻辑
          console.error('设备关联添加失败', error);
        });
    }
  });
},

    getAllDeviceRelation () {
    //注意回调函数的作用域!!!
    this.$http.get("/da/all_device_relation").then((response) => {
      this.tableData = response.data
    // console.log(response.data)
    })
  },
  formatRelationType(row, column, cellValue, index) {
    const typeMap = {
      0: '未知',
      1: 'ID同意',
      2: '购买新车',
      3: '更换屏幕',
      4: '交叉登录',
    };
    return typeMap[cellValue] || '未知';
  },


  },



  created: function () {
    this.getAllDeviceRelation ()
  },

  mounted: function () {
    // console.log("bubbles 挂载完毕")
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>